<template>
  <v-container>
    <v-card>
      <v-card-text>
        <v-container>
          <job-add-form></job-add-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import JobAddForm from "@/components/admin/JobAddForm";

export default {
  name: "configuration",
  components: {
    JobAddForm
  }
}
</script>
